import { gsap } from "gsap";

$(document).ready(function() {

    // Replace 'your-form-id' with the actual ID or class of your form
    $('.custom-select-2 select').find('option[value=""]').attr({
        'disabled': true,
        'hidden': true,
    });
    
    // Custom Select JS
    function customSelect() {
        var customSelect = $(".custom-select-2");
        customSelect.each(function() {
            var thisCustomSelect = $(this),
                options = thisCustomSelect.find("option"),
                firstOptionText = options.first().text();
            let isMultipleSelect = thisCustomSelect.find("select[multiple]").length ? true : false;

            var selectedItem = $("<div></div>", {class: "selected-item"}).appendTo(thisCustomSelect);

            var selectedItemSpan 
            if(!isMultipleSelect){
                selectedItemSpan = $("<span></span>", {class: "selected-item-text"}).appendTo(selectedItem).text(firstOptionText);
            }else{
                var itemsWrapper = $("<div></div>", {class: "items-wrpper"}).appendTo(selectedItem);
                if(!options.is("[hidden]")){
                    selectedItemSpan.appendTo(selectedItem).text(firstOptionText);
                }
            }

            var allItems = $("<div></div>", {class: "all-items all-items-hide"}).appendTo(thisCustomSelect);
            
            options.each(function() {
                var that = $(this),
                optionText = that.text();
                let isSelected = that.not("[hidden]").is("[selected]");
                
                var item = $("<div></div>", {
                    class: that.attr("disabled") ? "item hidden" : "item",
                    on: {
                        click: function() {
                            var $this = $(this)
                            var selectedOptionText = that.text();
                            selectedItem.removeClass("arrowanim");

                            
                            if(!isMultipleSelect){
                                $this.addClass("active")         
                                $this.parents(".custom-select-2").find(".all-items .item").not($this).removeClass("active")
                                selectedItemSpan.text(selectedOptionText).removeClass("arrowanim");
                            }else{
                                if(!$this.hasClass("active")){
                                    let multiselectedItem = $("<span></span>",{class: "selected-item-text tage"}).attr("data-option",$this.index()).text(selectedOptionText);


                                    itemsWrapper.append(multiselectedItem)
                                    // selectedItem.append(`<span class='selected-item-text tage' data-option="${$this.index()}">${selectedOptionText}</span>`)
                                    
                                    gsap.fromTo(multiselectedItem,{
                                        opacity: 0,
                                        y: !thisCustomSelect.hasClass("selected-opt") ? '15px' : 0,
                                    },{
                                        opacity: 1,
                                        y: 0,
                                        duration: 0.25,
                                    });
                                }else{
                                    selectedItem.find(`.selected-item-text.tage[data-option="${$this.index()}"]`).remove()
                                }
                                $this.toggleClass("active")         
                            }

                            gsap.fromTo(selectedItemSpan,{
                                opacity: 0,
                                y: !thisCustomSelect.hasClass("selected-opt") ? '15px' : 0,
                            },{
                                opacity: 1,
                                y: 0,
                                duration: 0.25,
                            });

                            gsap.to(allItems,{
                                opacity: 0,
                                y: '-15px',
                                duration: 0.25,
                                onComplete:()=>{
                                    allItems.addClass("all-items-hide");
                                    thisCustomSelect.removeClass("active")
                                }
                            });
                        }
                    }
                }).appendTo(allItems).text(optionText);

                if(isSelected){
                    thisCustomSelect.addClass("selected-opt")
                    $(".custom-select-2 .selected-item-text").text(optionText)
                }
            });
        });

        var selectedItem = $(".selected-item"),
            allItems = $(".all-items");

        selectedItem.on("click", function(e) {
            var currentSelectedItem = $(this),
                currentAllItems = currentSelectedItem.next(".all-items");
                if(currentAllItems.hasClass("all-items-hide")){
                    
                    gsap.fromTo(currentAllItems,{
                        opacity: 0,
                        y: '-15px',
                    },{
                        opacity: 1,
                        y: 0,
                        duration: 0.25,
                    });
                    if(allItems.not(currentAllItems).parents(".custom-select-2").hasClass("active")){
                        allItems.not(currentAllItems).parent(".custom-select-2").removeClass("active")
                        gsap.to(allItems.not(currentAllItems),{
                            opacity: 0,
                            y: '-15px',
                            duration: 0.25,
                            onComplete:()=>{        
                                allItems.not(currentAllItems).addClass("all-items-hide");
                            },
                        });
                    }
                    
                }else{  
                    gsap.to(currentAllItems,{
                        opacity: 0,
                        y: '-15px',
                        duration: 0.25,
                        onComplete:()=>{
                            currentAllItems.addClass("all-items-hide");
                            currentSelectedItem.parent(".custom-select-2").removeClass("active")
                            allItems.not(currentAllItems).parent(".custom-select-2").removeClass("active")
                        }
                    });
                }

            selectedItem.not(currentSelectedItem).removeClass("arrowanim");
            currentSelectedItem.parent(".custom-select-2").addClass("active")
            currentAllItems.removeClass("all-items-hide");
            currentSelectedItem.toggleClass("arrowanim");

            e.stopPropagation();
        });

        $(document).on("click", function() {
            var opened = $(".all-items:not(.all-items-hide)")

            gsap.to(opened.parent().find(".all-items"),{
                opacity: 0,
                y: '-15px',
                duration: 0.25,
                onComplete:()=>{
                    opened.parent().find(".all-items").addClass("all-items-hide");
                    opened.parent(".custom-select-2").removeClass("active")
                }
            });
            opened.parent().find(".selected-item").removeClass("arrowanim");
        });

        $(document).on('click', '.all-items .item', function(elem){

            var $thisInd = $(this).index(),
                $thisSel = $(this).parents('.custom-select-2').find('select');
            let isMultipleSelect = $thisSel.is("[multiple]") ? true : false;
            
            if(!isMultipleSelect ){
                $thisSel.find("option").removeAttr("selected") 
                $thisSel[0][$thisInd].setAttribute('selected',"")
            }else{
                $thisSel[0][$thisInd].toggleAttribute('selected');
            }
            if($(this).parents(".custom-select-2").find(".all-items .item.active").length){
                $(this).parents('.custom-select-2').addClass("selected-opt")
            }else{
                $(this).parents('.custom-select-2').removeClass("selected-opt")
            }
            $thisSel.val($thisSel[0][$thisInd].value)
            $(document).trigger("select2selected", elem);
            $thisSel.trigger("change")
        })
    }
    customSelect()

    $(document).on("wpcf7submit",function () {
        $(".custom-select-2").each(function () {
            let $this = $(this)
            setTimeout(() => {
                if($this.find(".wpcf7-not-valid-tip").length){
                    $this.addClass("invalid")
                }else{
                    $this.removeClass("invalid")
                }
            }, 10);
        })  
    })

    $(".wpcf7-form.init").on("change",function (e) { 
        e.target.closest(".wpcf7-form-control") && wpcf7.validate(e.currentTarget, {
            target: e.target
        })
    })
    $(".custom-select-2 select").on("change",function(){
        let thisParent = $(this).parents(".custom-select-2")
        setTimeout(() => {
            if(thisParent.find(".wpcf7-not-valid-tip").length){
                thisParent.addClass("not-valid")
            }else{
                thisParent.removeClass("not-valid")
            }
        }, 10);
    })

    document.addEventListener("wpcf7statuschanged",function() {
        setTimeout(() => {
            $(".wpcf7-form-control.wpcf7-not-valid").parents(".custom-select-2").addClass("not-valid")
        }, 10);
    })

})